module.exports = __webpack_public_path__ + "static/gallery29-21cb642b750fac2a034fcce124551796.jpg";